<template>
  <f7-page class="main-new-contract-page">
    <template #fixed>
      <TheNavbar
        nav-title="Nuevo contrato"
        back-btn-enable
        :style="appTheme"
      />
    </template>

    <div class="content-new-contract-line">
      <div class="content-new-contract-header padding-bottom">
        <div class="content-new-contract-info">
          <div
            v-if="contractId > 0"
            :class="[state === 1 ? 'content-new-contract-info__alert' : 'content-new-contract-info__confirm']"
          >
            <div class="padding-vertical-half padding-left text-align-center color-contrato">
              {{ (state === 1) ? 'CONTRATO EN PROPUESTA' : 'CONTRATO EN FIRME' }}
            </div>
            <div
              v-if="state === 1 && canValidate && contractId > 0"
              class="content-new-contract-info__check padding-vertical-half padding-right"
              @click="closeContract"
            >
              <f7-button
                color="green"
                small
                class="btn-color"
              >
                Validar
              </f7-button>
            </div>
          </div>
          <div class="content-new-contract-info__title padding-horizontal padding-top">
            {{ farmer.name }}
          </div>
          <div class="content-new-contract-info__subtitle padding-horizontal">
            {{ `${field.code} - ${field.name}` }}
          </div>
        </div>

        <f7-list class="padding-horizontal padding-top-half">
          <f7-list-input
            label="Fecha de inicio"
            type="date"
            placeholder="Fecha de inicio"
            min="1"
            clear-button
            :value="startDate"
            @input="startDate = $event.target.value"
          />
          <f7-list-input
            label="Fecha de fin"
            type="date"
            placeholder="Fecha de fin"
            min="1"
            clear-button
            :value="endDate"
            @input="endDate = $event.target.value"
          />
        </f7-list>
      </div>

      <div class="content-new-contract-add-line padding-horizontal padding-vertical-half">
        <div class="content-new-contract-add-line__title">
          Líneas de contrato ({{ contractLines.length }})
        </div>
        <img
          v-if="state === 1"
          style="margin-left: 16px;"
          :src="addIcon"
          width="30"
          height="30"
          @click="openNewLine"
        >
      </div>

      <div>
        <f7-block v-if="contractLines.length === 0">
          No hay ninguna línea
        </f7-block>
        <div
          v-else
          class="content-contract-line-list padding-horizontal"
        >
          <f7-list>
            <f7-list-item
              v-for="line in contractLines"
              :key="line.id"
              link="#"
              :media-item="true"
              :title="`${line.varietyName}`"
              @click="openSheet(line)"
            >
              <template #text>
                <div>
                  <strong>{{ `${line.quantity}${$t('common.kg')}` }}</strong> {{ `${line.price}€/${$t('common.kg').toUpperCase()}` }}
                </div>
              </template>

              <template #after>
                <div>
                  <strong>{{ line.amount }}</strong>€
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </div>
      </div>
      <TakePicture
        :images="imagesContract"
        @images-changed="imagesChanged"
      />

      <HIFormInputSignature
        v-if="!signed"
        class="margin-horizontal margin-top-half content-signature"
        label="Firma proveedor"
        :are-buttons-rounded="true"
        :signature="signature"
        @new-signature="updateSignature"
        @signature-cleared="signature = ''"
      />

      <div
        v-if="signed"
        class="content-signature padding-horizontal margin-top"
      >
        <span class="content-signature__label">
          Firma del proveedor
        </span>
        <div class="content-signature__msg margin-top">
          <img
            :src="checkIcon"
            width="48"
            height="48"
          >
          CONTRATO FIRMADO
          <!-- <span>Volver a firmar</span> -->
        </div>
      </div>

      <div
        v-if="BlockSendEmail() && state !== 0"
        class="padding-horizontal"
      >
        <f7-list
          media-list
        >
          <f7-list-item
            checkbox
            :checked="sendEmail"
            name="demo-media-checkbox"
            title="Enviar Contrato de compra"
            text="Enviar contrato de compra por email al proveedor"
            @change="sendEmail = $event.target.checked"
          />
        </f7-list>
      </div>
      <div v-if="state === 0">
        <f7-button
          col
          button
          large
          raised
          fill
          class="margin"
          :disabled="btnDisable"
          @click="SendEmailToClient"
        >
          Enviar Contrato de compra
        </f7-button>
      </div>
    </div>

    <div
      class="btn-fixed-bottom"
    >
      <f7-button
        v-if="state === 1"
        @click="saveContract"
      >
        {{ $t('common.save') }}
      </f7-button>
    </div>

    <!-- Action Sheet -->
    <f7-sheet
      class="demo-sheet"
      :opened="sheetOpened"
      @sheet:closed="sheetOpened = false"
    >
      <f7-page-content class="content-action-sheet padding-vertical-half">
        <div class="content-action-sheet__title text-align-center">
          {{ $t('common.whatDoYouWantToDo') }}
        </div>
        <div class="content-action-sheet__actions">
          <div class="text-align-center content-action-sheet__actions--delete">
            <img
              v-if="state === 1"
              :src="deleteIcon"
              @click="deleteContractLine(currentLine.id)"
            >
            <span>{{ $t('common.delete') }}</span>
          </div>
          <div class="text-align-center content-action-sheet__actions--edit">
            <img
              v-if="state === 1"
              :src="editButtonIcon"
              @click="openExistingLine(currentLine)"
            >
            <span>{{ $t('common.edit') }}</span>
          </div>
        </div>
      </f7-page-content>
    </f7-sheet>

    <NewContractLinePopUp
      :popup-opened="linePopUpOpen"
      :line="currentLine"
      :editable="state === 1"
      @popup-close="linePopUpOpen = false"
      @line-saved="lineSaved"
    />
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import HIFormInputSignature from '@/components/common/HIFormInputSignature.vue';
import TakePicture from '@/components/contracts/TakePicture.vue';
import NewContractLinePopUp from '@/components/contracts/NewContractLinePopUp.vue';
import FarmerService from '@/js/services/contracts/Farmers';
import FieldService from '@/js/services/contracts/Fields';

import { useParamRef } from '@erpagroapp/params';
import deleteIcon from '@/static/img/ic_button_delete.svg';
import addIcon from '@/static/img/ic_add_orange.svg';
import editButtonIcon from '@/static/img/ic_button_edit.svg';
import checkIcon from '@/static/img/ic_check.svg';
import ContractService from '@/js/services/contracts/Contracts';
import Api from '@/js/services/contracts/ApiContracts';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'NewContractPage',
  components: {
    TheNavbar,
    NewContractLinePopUp,
    HIFormInputSignature,
    TakePicture,
  },

  props: {
    fieldId: { type: Number, default: 0 },
    contractId: { type: Number, default: 0 },
  },

  data() {
    return {
      farmer: {},
      field: {},
      contractLines: [],
      linePopUpOpen: false,
      currentLine: {},
      idGenerator: -1,
      startDate: new Date().toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
      state: 1,
      signature: '',
      signed: false,
      sheetOpened: false,
      imagesContract: [],
      sendEmail: false,
      btnDisable: false,
      bloquearEnvioContratosNoConfirmados: useParamRef('BloquearEnvioContratosNoConfirmados'),
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    deleteIcon: () => deleteIcon,
    addIcon: () => addIcon,
    editButtonIcon: () => editButtonIcon,
    checkIcon: () => checkIcon,
    finalContract() {
      const finalContract = {
        id: this.contractId,
        field: this.field.id,
        startDate: this.startDate,
        endDate: this.endDate,
        lines: this.contractLines,
        sync_status: 1,
        state: this.state,
        signature: this.signature,
        images: this.imagesContract,
        sendEmail: this.sendEmail,
      };
      return finalContract;
    },
    canValidate() {
      const value = localStorage.getItem('esResponsable');
      return (value != null && value);
    },
  },
  async mounted() {
    f7.preloader.show();
    try {
      if (this.contractId > 0) {
        await this.loadContract(this.contractId);
        this.sendEmail = false;
      } else {
        this.sendEmail = true;
      }
      if (this.fieldId > 0) {
        await this.loadField(this.fieldId);
      }
    } finally {
      f7.preloader.hide();
    }
  },
  methods: {
    async loadContract(id) {
      const contract = await ContractService.getById(id);
      this.mapContract(contract);
    },
    async mapContract(contract) {
      this.startDate = contract.startDate;
      this.endDate = contract.endDate;
      this.contractLines = contract.lines;
      this.state = contract.state || 0;
      this.signature = contract.signature || '';
      this.signed = contract.signed || false;
      this.imagesContract = contract.images;

      let minimumLineIndex = -1;
      contract.lines.forEach((l) => {
        if (l.id < minimumLineIndex) {
          minimumLineIndex = l.id - 1;
        }
      });

      this.idGenerator = minimumLineIndex;
      await this.loadField(contract.field);
    },
    BlockSendEmail() {
      if (this.bloquearEnvioContratosNoConfirmados) {
        if (this.state === 1) {
          return false;
        }
        return true;
      } return true;
    },
    async loadField(id) {
      const field = await FieldService.getById(id);
      this.field = field;
      await this.loadFarmerData(field.farmer);
    },
    async loadFarmerData(id) {
      const farmer = await FarmerService.getById(id);
      this.farmer = farmer;
    },
    openNewLine() {
      this.currentLine = {};
      this.linePopUpOpen = true;
    },
    openExistingLine(line) {
      this.currentLine = {};
      this.currentLine = line;
      this.linePopUpOpen = true;
      this.sheetOpened = false;
    },
    lineSaved(line) {
      const newLine = line;
      if (newLine.id === 0) {
        newLine.id = this.idGenerator;
        this.idGenerator -= 1;
        this.contractLines.push(newLine);
      } else {
        for (let i = 0; i < this.contractLines.length; i += 1) {
          const element = this.contractLines[i];
          if (element.id === newLine.id) {
            this.contractLines[i] = newLine;
            break;
          }
        }
      }
    },
    deleteContractLine(id) {
      f7.dialog.create({
        title: `¿Seguro que quieres borrar la línea de contrato ${this.currentLine.varietyName} ?`,
        buttons: [
          {
            text: this.$t('common.cancel'),
          },
          {
            text: this.$t('common.delete'),
            color: 'red',
            onClick: () => {
              this.contractLines = this.contractLines.filter((c) => c.id !== id);
            },
          },
        ],
      }).open();
      this.sheetOpened = false;
    },
    openSheet(line) {
      this.sheetOpened = true;
      this.currentLine = line;
    },
    async saveContract() {
      if (!this.validateContract()) {
        return;
      }
      const contract = this.finalContract;
      try {
        if (this.contractId > 0) {
          await ContractService.updateById(this.contractId, contract);
        } else {
          delete contract.id;
          await ContractService.add(contract);
        }
        f7.views.main.router.back('', { ignoreCache: true });
      } catch (e) {
        HiNotification.Alert(this.$t('common.error'), e);
      }
    },
    async SendEmailToClient() {
      this.btnDisable = true;
      const contract = await ContractService.getById(this.contractId);
      contract.field = this.field;
      contract.field.farmer = this.farmer;
      const result = await Api.SendEmailContractPurchase(contract);
      if (result.data.Valor) {
        HiNotification.Toast('Correo enviado correctamente');
      } else {
        HiNotification.Toast('No se ha podido enviar el correo');
      }
      this.btnDisable = false;
    },
    validateContract() {
      if (this.startDate === '' || this.endDate === '') {
        HiNotification.Alert('Las fechas son obligatorias', 'Falta información');
        return false;
      }
      if (this.startDate > this.endDate) {
        HiNotification.Alert('La fecha inicio tiene que ser menor que la fecha de fin', 'Información incorrecta');
        return false;
      }

      if (this.contractLines.length === 0) {
        HiNotification.Alert('Tiene que haber al menos una línea de contrato', 'Falta información');
        return false;
      }

      return true;
    },
    updateSignature(newValue) {
      this.signature = newValue;
    },
    closeContract() {
      this.state = 0;
      this.saveContract();
    },
    imagesChanged(images) {
      //

      this.imagesContract = images;
    },
  },
};
</script>

<style lang="scss">
.main-new-contract-page {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="month"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  .smart-select .item-content .item-inner,
  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

  .item-content {
    .item-inner {
      .item-input-wrap {
        input {
          height: 54px;
          padding-left: 10px;
        }

        .input-clear-button {
          margin-top: -4px;
          margin-right: 15px;
        }
      }
    }
  }

  .content-new-contract-line {
    height: calc(100vh - 136px);
    overflow-y: scroll;
    padding-bottom: 10px;
  }

  .content-new-contract-header {
    background-color: var(--his-lightsnow);

    div {
      ul {
        background: var(--his-whispering-lilac);
      }
    }

    .list {
      ul {
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 7.5px));
        column-gap: 15px;
      }

      .item-content {
        padding-left: 0;

        .item-inner {
          padding-right: 0;

          .item-title {
            color: var(--his-darkgray);
            font-weight: 400;
            font-size: 14px;
          }

          input {
            padding-left: 7px;
            padding-right: 30px !important;
            background-color: #fff;
          }

          .input-clear-button::after {
            color: var(--his-darkgray);
            width: 35px;
          }
        }
      }
    }
  }

  .content-new-contract-info {
    margin-bottom: 20px;

    .color-contrato {
      color: var(--his-orange);
    }

    .btn-color {
      color: #fff;
    }

    &__alert,
    &__confirm {
      background-color: var(--his-peach-fuzz);
      color: var(--his-yellow);
      font-weight: 600;
      font-size: 14px;
    }

    &__alert {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .color-green {
      --f7-theme-color: var(--his-green);

      background-color: var(--his-green);
    }

    &__confirm {
      background-color: #cff7dd;
      color: var(--his-green);
    }

    &__title {
      color: var(--his-dark-blue);
      font-weight: 500;
      font-size: 16px;
    }

    &__subtitle {
      color: var(--his-darkgray);
      font-weight: 400;
      font-size: 14px;
    }
  }

  .content-new-contract-add-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--his-dark-blue);

    &__title {
      color: #fff;
      font-weight: 500;
    }
  }

  ::-webkit-calendar-picker-indicator {
    margin-left: 0;
  }

  .content-contract-line-list {
    .item-inner,
    .list ul {
      &::after {
        background-color: var(--his-lighblue);
        height: 2px;
      }
    }

    .item-title-row {
      align-items: center;

      .item-title {
        color: var(--his-dark-blue);
        font-size: 14px;
        font-weight: 500;
      }

      .item-after {
        div {
          background-color: var(--his-lighblue);
          color: var(--his-oliva);
          font-size: 14px;
          font-weight: 400;
          padding: 2px 10px;
          border-radius: 3px;
        }
      }
    }

    .item-text {
      color: var(--his-oliva);
      font-size: 13px;
      font-weight: 400;

      strong {
        font-size: 14px;
      }
    }
  }

  .content-signature {
    span {
      color: var(--his-oliva);
      font-size: 14px;
      margin-bottom: 5px;
      padding-left: 5px;
      display: block;
    }

    .input-signature__button {
      border: var(--f7-button-border-width, 0) solid var(--f7-button-border-color, var(--f7-theme-color));
      font-size: var(--f7-button-font-size);
      background-color: var(--his-mandarina);
      color: var(--f7-button-text-color, var(--f7-theme-color));
      height: var(--f7-button-height);
      border-radius: 3px;
    }

    .row {
      .col:first-child {
        .input-signature__button {
          background-color: var(--f7-button-fill-pressed-bg-color, var(--f7-theme-color-shade));
        }
      }
    }

    &__msg {
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      color: var(--his-green);
      font-weight: 500;
      font-size: 14px;

      img {
        align-self: center;
        margin-bottom: 8px;
      }

      span {
        font-size: 12px;
        font-weight: normal;
        text-decoration: underline;
        padding-top: 10px;
      }
    }
  }
}

.content-action-sheet {
  &__title {
    color: var(--his-dark-blue);
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      padding: 15px;
      display: flex;
      flex-direction: column;

      img {
        width: 48px;
        height: 48px;
      }

      span {
        font-weight: 400;
        font-size: 12px;
        padding-top: 5px;
      }
    }

    &--delete {
      span {
        color: var(--his-tomate);
      }
    }

    &--edit {
      span {
        color: var(--his-darkgray);
      }
    }
  }
}
</style>
